import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Dialog } from 'primereact/dialog';
import { handleGetRequest } from '../../service/GetTemplate';
import { endPoints } from '../../Config';
import { useDispatch } from 'react-redux';
import AddEditAdminModule from './AddEditAdminModule';

const AdminModule = () => {
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [rowRecord, setRowRecord] = useState(null);
    const [adminModule, setAllAdminModule] = useState([]);
    const [editable, setEditable] = useState(false);
    const [viewable, setViewable] = useState(false);

    const dispatch = useDispatch();

    const handleAdd = () => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(false);
    };

    const handleEdit = (rowData) => {
        setShowAddDialog(true);
        setEditable(true);
        setViewable(false);
        setRowRecord(rowData);
    };

    const handleView = (rowData) => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(true);
        setRowRecord(rowData);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    <Button
                        tooltip="Edit"
                        icon="pi pi-pencil"
                        tooltipOptions={{ position: 'top' }}
                        disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.isActive === 'N') ? true : false}
                        onClick={() => {
                            handleEdit(rowData);
                        }}
                        className="p-button-rounded p-button-primary mr-2 ml-2"
                    />
                    <Button
                        tooltip="View"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-eye"
                        onClick={() => {
                            handleView(rowData);
                        }}
                        className="p-button-rounded"
                        style={{ backgroundColor: '#F2AC57', border: 'none' }}
                    />
                </div>
            </>
        );
    };

    const getAdminModuleList = async () => {
        const response = await handleGetRequest(endPoints.getAllAdminModule, true, false, dispatch);
        if (response) {
            setAllAdminModule(response?.data);
        }
    };

    useEffect(() => {
        getAdminModuleList();
    }, []);

    const onHide = () => {
        setShowAddDialog(false);
        getAdminModuleList();
    };
    const onClose = () => {
        setShowAddDialog(false);
    };

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Admin Modules</h3>
                <div className="flex gap-2">
                    <Button label="Add New" icon="pi pi-plus" className="p-button-success p-button-sm" onClick={() => handleAdd()} />
                </div>
            </div>
            <Dialog
                header={<div>{editable ? 'Edit Admin Module' : viewable ? 'View Admin Module' : 'Add Admin Module'}</div>}
                visible={showAddDialog}
                onHide={onClose}
                breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                style={{ width: '40vw' }}
                draggable={false}
            >
                <AddEditAdminModule rowRecord={rowRecord} editable={editable} viewable={viewable} onHide={onHide} onClose={onClose} />
            </Dialog>

            <DataTable
                paginator
                rows={15}
                rowsPerPageOptions={[5, 10, 20]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                emptyMessage="No List found."
                responsiveLayout="scroll"
                value={adminModule}
                className="p-datatable-sm datatable-responsive"
            >
                <Column field="name" header=" Name" />
                <Column field="moduleIcon" header=" Icon" />
                <Column field="modulePath" header=" Path" />

                <Column header="Actions" body={actionBodyTemplate} className="Table__ActionHeading__CentredAlign" />
            </DataTable>
        </div>
    );
};

export default AdminModule;
